export default "__VITE_ASSET__b592e7bd__"